import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {VersioningService} from 'app/fragment/versioning/versioning.service';
import {AbstractSectionResolver} from 'app/routing/resolvers/abstract-section-resolver';
import {DocumentService} from 'app/services/document.service';
import {SectionService} from 'app/services/section.service';
import {ViewMode} from 'app/view/current-view';
import {CurrentLocation, ViewService} from 'app/view/view.service';

@Injectable({
  providedIn: 'root',
})
export class SectionCompareResolverService extends AbstractSectionResolver {
  protected breadcrumb: string = 'compare';
  protected routeName: string = 'Compare with previous versions';
  protected viewMode: ViewMode = ViewMode.COMPARE;
  protected location: CurrentLocation = CurrentLocation.COMPARE;

  constructor(
    protected documentService: DocumentService,
    protected sectionService: SectionService,
    protected versioningService: VersioningService,
    protected viewService: ViewService,
    protected snackBar: MatSnackBar,
    protected router: Router
  ) {
    super(documentService, sectionService, versioningService, viewService, snackBar, router);
  }
}
